import React, { createContext, useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../login/AuthContext';
import { hasConsent } from '../login/hasConsent';
import { is } from 'date-fns/locale';
const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favoriteSellers, setFavoriteSellers] = useState([]);
  const [favoriteCards, setFavoriteCards] = useState([]);
 const { userId, liveCsrfToken, isAuthenticated,jwtToken, loading } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();


  // Fetch and set favorite sellers
  const fetchFavoriteSellers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/favorites/sellers/${userId}`, {
        method: 'GET',
        credentials: 'include',
           headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
          "Authorization": `Bearer ${jwtToken}`
        },
      });

      if (response.ok) {
        const data = await response.json();
        setFavoriteSellers(data);
      }
    } catch (error) {
      console.error('Error fetching favorite sellers:', error);
    }
  };

  // Fetch and set favorite cards
  const fetchFavoriteCards = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/favorites/card`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
          "Authorization": `Bearer ${jwtToken}`
        },
      });

      if (response.ok) {
        const data = await response.json();
        setFavoriteCards(data);
       
      }
    } catch (error) {
      console.error('Error fetching favorite cards:', error);
    }
  };

useEffect(() => {
  if (isAuthenticated && parseInt(userId) > 0) {
    fetchFavoriteSellers();
    fetchFavoriteCards();
  } else {
    setFavoriteCards([]);
    setFavoriteSellers([]);
  }
}, [userId, isAuthenticated,loading]);

 
  // Add/remove functions for sellers
  const addFavoriteSeller = async (sellerId) => {
    if (!userId) {
      if (hasConsent()) {
      localStorage.setItem('intendedPath', window.location.pathname + window.location.search);}
      navigate('/login');
      return;
    }

    try {
      await fetch(`${process.env.REACT_APP_API_BASE}/favorites/sellers/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ userId, sellerId }),
      });

      setFavoriteSellers((prev) => [...prev, { sellerId }]);
      console.log('seller favortiesd')
    } catch (error) {
      console.error('Error adding favorite seller:', error);
    }
  };

  const removeFavoriteSeller = async (sellerId) => {
    if (!userId) {
      if (hasConsent()) {
      localStorage.setItem('intendedPath', window.location.pathname + window.location.search);}
navigate('/login');
      return;
    }

    try {
      await fetch(`${process.env.REACT_APP_API_BASE}/favorites/sellers/remove`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ userId, sellerId }),
      });

      setFavoriteSellers((prev) => prev.filter((fav) => parseInt(fav.sellerId) !== parseInt(sellerId)));
      console.log('favorites seller reomved')
    } catch (error) {
      console.error('Error removing favorite seller:', error);
    }
  };

  // Add/remove functions for cards
  const addFavoriteCard = async (userCardId,cardId) => {
    if (!userId) {
      if (hasConsent()) {
      localStorage.setItem('intendedPath', window.location.pathname + window.location.search);}
      navigate('/login');
      return;
    }

    // Check if the card is already in favorites
    if (favoriteCards.some((fav) => fav.userCardId === userCardId)) {
      console.log('Card is already in favorites.');
      return;
    }

    console.log('isFavoriteCards',userCardId,favoriteCards)
    try {
      await fetch(`${process.env.REACT_APP_API_BASE}/favorites/card/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ userId, userCardId,cardId }),
      });
    
      setFavoriteCards((prev) => [...prev, { userCardId: userCardId }]);
      return true
    } catch (error) {
      console.error('Error adding favorite card:', error);
      return false
    }
  };

  const removeFavoriteCard = async (userCardId) => {
    if (!userId) {
      if (hasConsent()) {
      localStorage.setItem('intendedPath', window.location.pathname + window.location.search);}
      navigate('/login');
      return;
    }

    try {
      await fetch(`${process.env.REACT_APP_API_BASE}/favorites/card/remove`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ userId, userCardId }),
      });

      setFavoriteCards((prev) => prev.filter((fav) => fav.userCardId !== userCardId));
      return true
    } catch (error) {
      
      console.error('Error removing favorite card:', error);
      return false
    }
  };

  return (
    <FavoritesContext.Provider
      value={{
        favoriteSellers,
        favoriteCards,
        setFavoriteCards,
        addFavoriteSeller,
        removeFavoriteSeller,
        addFavoriteCard,
        removeFavoriteCard,
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
